import type {
  IGetChartChanceHistoryRequestParams,
  IGetChartChanceHistoryResponseBody,
  IGetChartNewsMarkersRequestParams,
  IGetChartNewsMarkersResponseBody,
  IGetChartVolumeRequestParams,
  IGetChartVolumeResponseBody,
} from "~/feature/chart/types";
import { api } from "~/store/api";

const API_PREFIX = "/charts";

export const chartApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChartChanceHistory: builder.query<
      IGetChartChanceHistoryResponseBody,
      IGetChartChanceHistoryRequestParams
    >({
      query: (params) => ({
        url: `${API_PREFIX}/chance-history`,
        params,
      }),
      extraOptions: { latestOnly: true },
    }),
    getChartVolume: builder.query<
      IGetChartVolumeResponseBody,
      IGetChartVolumeRequestParams
    >({
      query: (params) => ({
        url: `${API_PREFIX}/volume`,
        params,
      }),
      extraOptions: { latestOnly: true },
    }),
    getChartNewsMarkers: builder.query<
      IGetChartNewsMarkersResponseBody,
      IGetChartNewsMarkersRequestParams
    >({
      query: (params) => ({
        url: `${API_PREFIX}/news-markers`,
        params,
      }),
      extraOptions: { latestOnly: true },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetChartChanceHistoryQuery,
  useGetChartNewsMarkersQuery,
  useGetChartVolumeQuery,
} = chartApi;
